module.exports = __webpack_public_path__ + "img/swiperRight.41af35a1.svg";